import {subscribeExt} from "../modules/subscribe";

export function chroniclePage() {

    function fix_size($img_container) {
        var img_cl = $img_container+' img';
        var images = $(img_cl);

        images.each(setsize);

        function setsize() {
            var img = $(this),
                img_dom = img.get(0),
                container = img.parents($img_container);
            if (img_dom.complete) {
                resize();
            } else{
                img.one('load', resize);
            }

            function resize() {
                //console.log('container', img.attr('data-img-w') / img.attr('data-img-h'));
                //console.log('container', img_dom.width / img_dom.height);

                if ((container.width() / container.height()) > (img_dom.width / img_dom.height)) {
                    img.width('110%');
                    img.height('auto');
                } else {
                    img.height('110%');
                    img.width('auto');
                }
            }
        }
    }

    function outpitItem(item) {
        var output = '';
        output += '<div class="grid-item ' + item.class + '">';
        output += '<a href="' + item.url + '" title="' + item.title + '" style="background-image: url(' + item.thumbnail + ');">';
        output += '<img src="' + item.thumbnail + '" alt="' + item.title + '">';
        output += '</a><h4>' + item.title + '</h4></div>';

        return output;
    }

    function actions() {
        if($('body').hasClass('post-type-archive-secular-chronicle')){
            subscribeExt(500);
        }

        if($('.secular-chronicle').length > 0) {

            const firstposts = 10;
            const per_page = 5;

            var msnry = new Masonry('.grid', {
                itemSelector: '.grid-item',
                columnWidth: '.grid-col-sizer',
                gutter: '.grid-gutter-sizer',
                percentPosition: true,
                stagger: 30,
                visibleStyle: {transform: 'translateY(0)', opacity: 1},
                hiddenStyle: {transform: 'translateY(100px)', opacity: 0},
            });

            var infScroll = new InfiniteScroll('.grid', {
                path: function () {
                    var offset = firstposts + ((this.pageIndex - 1) * per_page);
                    return revent_data.site_url+'/wp-json/wp/v2/secular-chronicle?offset=' + offset + '&per_page=' + per_page;
                },
                responseType: 'text',
                outlayer: msnry,
                status: '.page-load-status',
                history: false,
            });

            var proxyElem = document.createElement('div');
            infScroll.on('load', function (response) {
                var data = JSON.parse(response);
                var itemsHTML = data.map(outpitItem).join('');
                proxyElem.innerHTML = itemsHTML;
                var items = proxyElem.querySelectorAll('.grid-item');

                imagesLoaded(items, function () {
                    infScroll.appendItems(items);
                    msnry.appended(items);
                });
            });

            infScroll.loadNextPage();


            fix_size('.chronicle-item a');
        }
    }

    actions();
}


// WEBPACK FOOTER //
// ./assets/js/pages/chronicle.js